import React from 'react'
import { Language } from '../language'
import { LanguageContext } from '../contexts'

import './LanguageCheckboxes.scss'

export interface LanguageCheckboxesProps {
	allLanguages: Set<Language>
	availableLanguages: Set<Language>
	selectedLanguages: Set<Language>
	setLanguages: (languages: Set<Language>) => void
}

export function LanguageCheckboxes(props: LanguageCheckboxesProps) {
	const { localizedText } = React.useContext(LanguageContext)

	return (
		<div className='language-checkboxes field'>
			<label className='label'>{localizedText.Language}</label>
			<LanguageCheckbox {...props} checkboxLanguage='English' />
			<LanguageCheckbox {...props} checkboxLanguage='French' />
		</div>
	)
}

export default LanguageCheckboxes

export interface LanuageCheckboxProps extends LanguageCheckboxesProps {
	checkboxLanguage: Language
}

function LanguageCheckbox(props: LanuageCheckboxProps) {

	const { localizedText } = React.useContext(LanguageContext)
	const checked = props.availableLanguages.has(props.checkboxLanguage) && props.selectedLanguages.has(props.checkboxLanguage)
	const disabled = !props.availableLanguages.has(props.checkboxLanguage)

	const handleChange = () => {
		const updatedLanguages = new Set(props.selectedLanguages)

		if (updatedLanguages.has(props.checkboxLanguage)) updatedLanguages.delete(props.checkboxLanguage)
		else updatedLanguages.add(props.checkboxLanguage)

		// we don't allow the user to select zero languages
		if (!disabled && updatedLanguages.size > 0) props.setLanguages(updatedLanguages)
	}


	return (
		<div className='control'>
			<label className='checkbox'>
				<input type='checkbox' onChange={handleChange} checked={checked} disabled={disabled}></input>
				{localizedText[props.checkboxLanguage]}
			</label>
		</div>
	)
}